import { Component, OnInit, computed, input, model, signal } from "@angular/core"
import { NgClass } from "@angular/common"
import { FormValueControl } from "@angular/forms/signals"
import { SearchableSelectOption } from "src/app/models"
import { LocationsService } from "src/app/services"
import { SearchableSelectComponent } from "../searchable-select/searchable-select.component"
import { MatIcon } from "@angular/material/icon"

interface Option {
    masterId: string
    name: string
}

@Component({
    selector: "valben-locations-input",
    templateUrl: "./locations-input.component.html",
    standalone: true,
    imports: [NgClass, SearchableSelectComponent, MatIcon],
})
export class LocationsInputComponent implements FormValueControl<string[]>, OnInit {
    value = model.required<string[]>()
    title = input("")
    error = input(false)
    invalid = input(false)

    hasError = computed(() => this.error() || this.invalid())

    /** Chips to render: the picked ids resolved to names. */
    selected = computed<Option[]>(() => {
        const names = this._namesById()
        return this.value().map(id => ({ masterId: id, name: names.get(id) ?? "" }))
    })

    options = signal<SearchableSelectOption<string>[]>([])
    availableOptions = computed(() => this.options().filter(option => !this.value().includes(option.value)))
    loading = signal(true)
    dropdownOpen = false
    pickedId: string | null = null

    private _namesById = signal(new Map<string, string>())

    constructor(private _locationsService: LocationsService) {}

    ngOnInit(): void {
        this._locationsService.GetAllCached().subscribe({
            next: locations => {
                const resolved = locations.map(l => ({ masterId: l.masterId, name: l.names?.["hr"] ?? "" }))
                const options = resolved.map(option => ({
                    value: option.masterId,
                    label: option.name,
                    searchText: option.name,
                }))
                this.options.set(options)
                this._namesById.set(new Map(resolved.map(option => [option.masterId, option.name])))
                this.loading.set(false)
            },
            error: () => this.loading.set(false),
        })
    }

    add(id: string | null): void {
        this.pickedId = null
        if (!id) return

        if (this.value().includes(id)) return
        this.value.update(ids => [...ids, id])
    }

    remove(index: number): void {
        this.value.update(ids => ids.filter((_, i) => i !== index))
    }

    toggleDropdown(): void {
        this.dropdownOpen = !this.dropdownOpen
        this.pickedId = null
    }
}
